import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";
import { ReactNode } from "react";
import { UIValidationTooltip } from "../BuildlingBlocks/UIValidationTooltip";

export function PropertyEditorValidationTooltip(props: {
    editObject: object;
    propertyName: string;
    error?: string | { message: string; issues?: ValidationIssue[] };
    children?: ReactNode;
}) {
    let valIssue: { message: string; issues?: ValidationIssue[] } | undefined;

    if (typeof props.error === "string")
        valIssue = getPropertyEditorValidationIssues(props.editObject, props.propertyName, props.error);
    else valIssue = props.error;

    return <UIValidationTooltip validationIssues={valIssue?.issues}>{props.children}</UIValidationTooltip>;
}

export function getPropertyEditorValidationIssues(
    editObject: object,
    fieldName: string,
    error?: string,
): { message: string; issues?: ValidationIssue[] } | undefined {
    if (error) return { message: error };

    let valMethod = Reflect.get(editObject, "getDesignValidationIssues");
    if (valMethod) {
        valMethod = valMethod.bind(editObject);
        let res = valMethod() as ValidationIssue[];

        if (res) {
            let filteredRes = res.filter((r) => r.dataName === fieldName);

            if (filteredRes && filteredRes.length !== 0) {
                if (filteredRes.length === 1) return { message: filteredRes[0].issue, issues: filteredRes };
                else return { message: "Issues: " + filteredRes.length, issues: filteredRes };
            }
        }
    }
}
